RivalIQ.apps.Analyze.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const page = RivalIQ.configuration.menus.getConfiguration().CROSS_CHANNEL;

    curations.Positioning = Dashboard.models.Curation.extend({
        title: page.name,

        widgetsView: Dashboard.views.ColumnCurationView,
        loadConfiguration: function () {
            return RivalIQ.data.chartConfigurations.fetch({
                channel: 'positioning'
            });
        },

        page: page,
        timePeriod: RivalIQ.state.timePeriods.types.TODAY
    });
});
